import { useEffect } from "react";

export interface SocialMeta {
  type?: "website" | "article";
  description?: string;
}

function upsertMeta(attr: "name" | "property", key: string, content: string): void {
  let meta = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute(attr, key);
    document.head.appendChild(meta);
  }
  meta.content = content;
}

export function usePageMeta(title: string, description: string, canonical?: string, social?: SocialMeta): void {
  const ogType = social?.type ?? "website";
  const ogDescription = social?.description ?? description;
  useEffect(() => {
    document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", ogDescription);
    upsertMeta("property", "og:type", ogType);
    upsertMeta("property", "og:site_name", "Gepeto.life");
    upsertMeta("property", "og:locale", "pt_BR");
    if (canonical) upsertMeta("property", "og:url", canonical);
    upsertMeta("name", "twitter:card", "summary");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", ogDescription);
  }, [title, description, canonical, ogType, ogDescription]);

  useEffect(() => {
    if (!canonical) return;
    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = canonical;
    const node = link;
    return () => node.remove();
  }, [canonical]);
}
